export const SUBMIT_TYPES = [
  { label: "Auto submit", value: 0 },
  { label: "Manual Submit", value: 1 },
];
